import { BidV2Status } from "../../../../../autogen/bff-api";

// A bid is shown as the read-only single page (instead of the editable wizard) once it reaches a
// terminal status. A draft — including a draft whose signing is in flight — stays on the wizard so
// the signing flow in ReviewStep keeps working.
export const isReadonlyBidStatus = (status: BidV2Status): boolean =>
  status === BidV2Status.Submitted ||
  status === BidV2Status.Awarded ||
  status === BidV2Status.Rejected;
